import type { RestConnectorConfig } from "oi-ecp-data-connector";
import { Public } from "oi-ecp-data-connector";
import { DataConnectorBase } from "./dataConnectorBase";

const config: RestConnectorConfig = {
  baseUrl: "",
  defaultHeaders: {},
  restApiConfig: {
    uploadFile: {
      url: "",
      method: "PUT",
      contentType: "html",
    },
  },
};

export class S3DataConnector extends DataConnectorBase {
  constructor() {
    super(config);
  }

  private configureUploadEndpoint(presignedUrl: string, platformId: string) {
    const endpoints = this.getEndpoints();
    if (!endpoints?.uploadFile) {
      throw new Error("Endpoint uploadFile not configured.");
    }

    endpoints.uploadFile.url = presignedUrl;
    endpoints.uploadFile.headers = {
      "Content-Type": "text/html",
      "x-amz-server-side-encryption": "AES256",
      "x-amz-meta-platform-id": platformId,
    };
  }

  @Public({
    description: "Upload HTML to S3 using presigned URL",
  })
  async uploadFile(data: string, presignedUrl: string, platformId = ""): Promise<void> {
    this.configureUploadEndpoint(presignedUrl, platformId);

console.log("Data " + data);

    await this.restCallStrict<null>("uploadFile", data);
  }
}
